Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var useMatchMedia = require('./useMatchMedia.js');
var utils = require('./utils.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

var IS_BROWSER = typeof window !== 'undefined';
var SUPPORTS_TOUCH = IS_BROWSER && (utils.isPointerEventsSupported() || utils.isTouchSupported());
var Mq = function (_a) {
    var children = _a.children, _b = _a.query, query = _b === void 0 ? '' : _b, touch = _a.touch, defaultMatchMediaValue = _a.defaultMatchMediaValue, onMatchChange = _a.onMatchChange;
    var queryMatches = useMatchMedia.useMatchMedia(query, defaultMatchMediaValue)[0];
    var touchPass = touch === undefined ? true : touch === SUPPORTS_TOUCH;
    var matches = touchPass && (!query || queryMatches);
    React.useEffect(function () {
        if (onMatchChange) {
            onMatchChange(matches);
        }
    }, [matches, onMatchChange]);
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return React__default.default.createElement(React.Fragment, null, matches && IS_BROWSER ? children : null);
};

exports.Mq = Mq;
